export default __webpack_public_path__ + "static/media/ASSEMBLEIA DA UNIVERSIDADE-03.2024.d445766d.pdf";